import React from 'react';

export const projectsPageFilterContext = React.createContext({});
